
import { useApi } from "hooks"
import { useQuery } from "@tanstack/react-query"

const useGetNextReward = () => {

  const { apiFetch } = useApi()

  const url = '/advertisements/reward';

  const getNextReward = () => {
    return apiFetch({ url })
      .then(res => res.data)
  }

  const options = {
    staleTime: 0,
    placeholderData: null,
    enabled: false,
  }

  return {
    ...useQuery(['nextReward'], getNextReward, options),
  }

}

export default useGetNextReward
